Ext.define('SA.view.Button', {
    alias: 'widget.sa-button',
    extend: 'Ext.Component',

    activeCls: 'sa-button-active',
    autoEl: 'a',
    baseCls: 'sa-button',
    disabledWithRetainedPointerCursorCls: 'sa-button-disabled-with-retained-pointer-cursor',
    htmlEncode: true,
    maskOnDisable: false,
    overCls: 'sa-button-over',

    renderTpl: [
        '<tpl if="icon"><svg class="sa-button-svg"><use href="#{icon}"></use></svg></tpl>',
        '<span class="sa-button-text">{text}</span>'
    ],

    beforeRender() {
        if (this.arrow) {
            this.addCls('sa-button-arrow');
        }

        this.ifCls(this.autoEl === 'button', 'sa-button-with-button-el');

        this.protoEl.unselectable();

        this.callParent();

        Ext.applyIf(this.renderData, this.getTemplateArgs());
    },

    disableWithOptions({clearOverCls = false, retainPointerCursor = false}) {
        if (this.hasCls(this.overCls)) {
            if (clearOverCls) {
                this.removeCls(this.overCls);
            }

            if (retainPointerCursor) {
                this.addCls(this.disabledWithRetainedPointerCursorCls);
                this.el.on('mouseleave', () => this.removeCls(this.disabledWithRetainedPointerCursorCls), null, {single: true});
            }
        }

        this.disable();
    },

    getTemplateArgs() {
        var text = this.text;

        return {
            icon: this.icon,
            text: this.htmlEncode ? Ext.String.htmlEncode(text) : text
        };
    },

    initEvents() {
        this.callParent();

        this.el.on({
            click: this.onClick,
            keydown: this.onKeyDown,
            mousedown: this.onMouseDown,

            scope: this
        });
    },

    isActive() {
        return this.hasCls(this.activeCls);
    },

    onClick() {
        if (!this.disabled) {
            Ext.callback(this.handler, this.scope || this, [this]);

            this.fireEvent('click', this);
        }
    },

    onDocMouseUp() {
        this.setInactive();
    },

    onKeyDown(ev) {
        var key = ev.getKey();

        if (key === ev.SPACE) {
            this.onClick();
        }
    },

    onMouseDown() {
        if (!this.disabled && !this.isActive()) {
            Ext.getDoc().on('mouseup', this.onDocMouseUp, this, {single: true});

            this.setActive();
        }
    },

    setActive() {
        this.addCls(this.activeCls);
    },

    setEnabled(enabled) {
        this.setDisabled(!enabled);
    },

    setInactive() {
        this.removeCls(this.activeCls);
    },

    setText(text) {
        var el = this.el,
            textEl;

        this.text = text;

        if (el) {
            if (this.htmlEncode) {
                text = Ext.String.htmlEncode(text);
            }

            textEl = el.down('.sa-button-text', true);

            textEl.innerHTML = text;

            this.updateLayout();
        }
    }
});
